import {
  BUSINESSCARD_NOTIFICATION,
  CRM_ENRICHED,
  EMAIL_SEND_CRM,
  EXTRACTED_TASKS,
  GET_EMAIL,
  GET_EMAIL_ERROR,
} from "../actions/types";

const initialState = {
  businessCardNotification: {},
  sendEmailNotification: false,
  email: [],
  enriched: [],
  emailError: "",
  tasks: {},
};

// const initialState = {
//   images: {}, //JSON.parse(localStorage.getItem("images")),
//   pictureNotification: "",
//   pictureError: "",
//   // when we fetch data takes some ms to get
// };

//will later get state from api

export default function (state = initialState, action) {
  let images = state.images;
  switch (action.type) {
    case BUSINESSCARD_NOTIFICATION:
      return {
        ...state,
        businessCardNotification: action.payload,
      };
    case EMAIL_SEND_CRM:
      return {
        ...state,
        sendEmailNotification: action.payload,
      };

    case CRM_ENRICHED:
      return {
        ...state,
        enriched: action.payload,
      };
    case GET_EMAIL:
      return {
        ...state,
        email: action.payload,
        emailError: "",
      };
    case GET_EMAIL_ERROR:
      return {
        ...state,
        emailError: action.payload,
      };
    case EXTRACTED_TASKS:
      console.log("acikitit", action.payload);
      if (action.payload.id && action.payload.tasks) {
        return {
          ...state,
          tasks: { ...state.tasks, [action.payload.id]: action.payload.tasks },
        };
      } else
        return {
          ...state,
        };
    default:
      return state;
  }
}
